export default "__VITE_PUBLIC_ASSET__739992b3__"